// extracted by mini-css-extract-plugin
export var box = "Contacts-module--box--80433";
export var box_md = "Contacts-module--box_md--128bf";
export var box_xmd = "Contacts-module--box_xmd--e68c8";
export var box_flex = "Contacts-module--box_flex--bcac5";
export var box_lg = "Contacts-module--box_lg--5c40d";
export var box_sm = "Contacts-module--box_sm--bf79a";
export var box_outer = "Contacts-module--box_outer--229c7";
export var box_whiteBg = "Contacts-module--box_white-bg--a6eef";
export var box_noMarginBottom = "Contacts-module--box_no-margin-bottom--1be5b";
export var box_noPadding = "Contacts-module--box_no-padding--2452c";
export var box_outerGray = "Contacts-module--box_outer-gray--7c732";
export var box_dark = "Contacts-module--box_dark--463de";
export var box_zIndex = "Contacts-module--box_z-index--6889d";
export var box_zIndex6 = "Contacts-module--box_z-index-6--738f8";
export var box_eventsWithLine = "Contacts-module--box_events-with-line--1171f";
export var box_featuresAo = "Contacts-module--box_features-ao--6903b";
export var box_verticalPaddings = "Contacts-module--box_vertical-paddings--54c8b";
export var clearP = "Contacts-module--clearP--55fb4";
export var clearP_vc = "Contacts-module--clearP_vc--d7c2f";
export var link = "Contacts-module--link--288e6";
export var linkEmail = "Contacts-module--linkEmail--8ecfe";
export var icon = "Contacts-module--icon--9bb31";
export var phone = "Contacts-module--phone--72ca7";
export var mail = "Contacts-module--mail--c1b49";
export var fadeInAnimation = "Contacts-module--fadeInAnimation--fc010";
export var placeHolderShimmer = "Contacts-module--placeHolderShimmer--f553d";